module.exports = __webpack_public_path__ + "img/silver-medal.aaf01e9d.svg";